export default [
  {
    name: 'Workers',
    number: 5,
    maxNumberPerHR: 16,
    salary: 1800,
    hireCost: 4000,
    description: 'Workers build aircraft',
  },
  {
    name: 'Foremen',
    number: 0,
    maxNumberPerHR: 4,
    salary: 2600,
    hireCost: 6000,
    description: 'Foremen help and supervise the workers ',
  },
  {
    name: 'Human Resources',
    number: 0,
    maxNumberPerHR: 1,
    salary: 3200,
    hireCost: 9000,
    description: 'HR care about all employees',
  },
  {
    name: 'Traders',
    number: 0,
    maxNumberPerHR: 3,
    salary: 3800,
    hireCost: 10000,
    description: 'Traders keep high the price of aircraft',
  },
  {
    name: 'Engineers',
    number: 0,
    maxNumberPerHR: 2,
    salary: 5000,
    hireCost: 25000,
    description: 'Engineers develop new aircraft',
  },
];
